import { Typography,Paper,Box,Button } from '@mui/material';
import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from 'recharts';

// Custom tooltip component
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div className="custom-tooltip" style={{ backgroundColor: "#fff", padding: "10px", border: "1px solid #ccc" }}>
        {Object.keys(data).map((key) => {
          if (key !== 'Index') {
            return <p key={key} className="intro">{`${key}: ${data[key]}`}</p>;
          }
          return null;
        })}
      </div>
    );
  }

  return null;
};

const InfoBox = ({ title, value }) => (
    <Paper elevation={3} style={{ padding: '1px', marginBottom:"2px",height:"40px",backgroundColor: '#205295' }}>
      <Typography style={{ fontWeight: 'bold', color: 'white',fontSize:"20px" }}>
        {title} : {value}
      </Typography>
      
    </Paper>
  );

const Visualization = ({ visualizationData }) => {
  const newWindowRef = useRef(null);

  const openVisualization = () => {
    const newWindow = window.open('', '_blank');
    newWindowRef.current = newWindow;

    ReactDOM.render(
        <React.StrictMode>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
    <InfoBox title="The model MSE Error" value={visualizationData.mse} />
    <InfoBox title="The model R2 Score" value={visualizationData.r2} />
  </Box>

        <ResponsiveContainer width="100%" height="90%">
            
          <LineChart
            data={visualizationData.visualization_data}
            margin={{
              top: 20, // Increased top margin to make room for the legend if needed
              right: 30,
              left: 20,
              bottom: 25, // Increased bottom margin to make room for the X-axis label
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="Index">
              {/* Increased offset for more space between the X-axis label and the axis */}
              <Label value="Index" offset={-5} position="insideBottom" />
            </XAxis>
            <YAxis label={{ value: 'Value', angle: -90, position: 'insideLeft' }} />
            <Tooltip content={<CustomTooltip />} />
            {/* Adjust the legend's position if necessary */}
            <Legend verticalAlign="top" wrapperStyle={{ paddingBottom: '10px' }} />
            <Line type="monotone" dataKey="Actual" stroke="#8884d8" activeDot={{ r: 8 }} />
            <Line type="monotone" dataKey="Predicted" stroke="#82ca9d" />
          </LineChart>
        </ResponsiveContainer>
      </React.StrictMode>
      ,
      newWindow.document.body
    );

    newWindow.document.title = 'Visualization Chart';
  };

  return (
    <>
    <Typography variant="h5" style={{ color: 'white' }} >Visualization</Typography>
    <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        padding: '15px'}}>
      <Button onClick={openVisualization} style={{color:'black',width:'100%',backgroundColor:'white'}}>Show Visualization</Button>
    </Box>
    
    </>
  );
};

export default Visualization;
